"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var react_router_1 = require("react-router");
var Layout_1 = require("./components/Layout");
var AuthorizeRoute_1 = require("./components/api-authorization/AuthorizeRoute");
var ApiAuthorizationRoutes_1 = require("./components/api-authorization/ApiAuthorizationRoutes");
var ApiAuthorizationConstants_1 = require("./components/api-authorization/ApiAuthorizationConstants");
//type imports
var Home_1 = require("./components/Home/Home");
var tnc_1 = require("./components/Legals/tnc");
var disclaimer_1 = require("./components/Legals/disclaimer");
var HelperInfo_1 = require("./components/HelperInfo/HelperInfo");
var PrivacyPolicy_1 = require("./components/Legals/PrivacyPolicy");
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //< !--AuthorizeRoute exact path = '/' component = { LoadingScreen } / -->
    App.prototype.render = function () {
        return (React.createElement(Layout_1.Layout, null,
            React.createElement(react_router_1.Route, { path: "/tnc", component: tnc_1.default }),
            React.createElement(react_router_1.Route, { path: "/disclaimer", component: disclaimer_1.default }),
            React.createElement(react_router_1.Route, { path: "/privacy", component: PrivacyPolicy_1.default }),
            React.createElement(react_router_1.Route, { path: "/assumptions", component: HelperInfo_1.default }),
            React.createElement(react_router_1.Route, { path: ApiAuthorizationConstants_1.ApplicationPaths.ApiAuthorizationPrefix, component: ApiAuthorizationRoutes_1.default }),
            React.createElement(AuthorizeRoute_1.default, { exact: true, path: '/', component: Home_1.default })));
    };
    App.displayName = App.name;
    return App;
}(react_1.Component));
exports.default = App;
//# sourceMappingURL=App.js.map